import { Theme } from '@mui/material/styles';

export const styles = {
  appBar: (theme: Theme, isBackground: boolean) => ({
    position: 'fixed',
    zIndex: 9998,
    width: '100%',
    top: 0,
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    px: '20px',
    background: isBackground
      ? theme.palette.common.surface['surface 5']
      : 'none',
  }),
  container: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  loader: (theme: Theme) => ({
    width: '100%',
    position: 'absolute',
    height: '1px',
    bottom: 0,
    left: 0,
    '& .MuiLinearProgress-root': {
      backgroundColor: theme.palette.action.active,
    },
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.primary.main,
    },
  }),
  actions: {
    display: 'flex',
    gap: '8px',
    '& button': {
      height: '49px',
      padding: '16px 24px',
    },
  },
  wrapper: {
    position: 'relative',
    ml: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
    flexShrink: 0,
  },
  menuWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
  },
  tokens: (theme: Theme) => ({
    display: 'flex',
    borderRadius: '0 16px 16px 0',
    gap: '5px',
    '& .MuiButton-endIcon': {
      display: 'none',
    },
    [theme.breakpoints.down('lg')]: {
      p: '14px 9px',
      minWidth: '38px',
      gap: 0,
      '& .MuiButton-endIcon': {
        ml: '4px',
        display: 'inherit',
      },
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiTypography-root': {
        display: 'none',
      },
      '& .MuiButton-endIcon': {
        m: 0,
      },
    },
  }),
  tokenLabel: (theme: Theme) => ({
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  }),
  profile: (theme: Theme) => ({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: theme.palette.warning.dark,
  }),
  buttonWrapper: (theme: Theme, isNoToken: boolean) => ({
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    padding: '0 8px',
    borderRadius: isNoToken ? '16px' : '0 16px 16px 0',
    transition: 'all 0.3s ease-out',
    '&:hover': {
      background: isNoToken ? 'none' : theme.palette.common.action['hover 2'],
    },
    [theme.breakpoints.down('md')]: {
      borderRadius: '16px',
    },
  }),
  boxButton: (theme: Theme) => ({
    cursor: 'pointer',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
    },
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: theme.palette.common.action['normal 2'],
    borderRadius: '28px',
    padding: '8px 8px 8px 10px',
  }),
  button: (theme: Theme) => ({
    borderRadius: '16px 0 0 16px',
    [theme.breakpoints.down('lg')]: {
      p: '14px 9px',
      minWidth: '38px',
      '& .MuiTypography-root': {
        display: 'none',
      },
      '& .MuiButton-startIcon': {
        m: 0,
      },
    },
  }),
  active: (theme: Theme) => ({
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.main,
    },
  }),
  wrapperProjects: (theme: Theme) => ({
    background: 'rgba(0, 0, 0, 0.4)',
    opacity: 0,
    visibility: 'hidden',
    transform: 'translateY(-100%)',
    mt: '80px',
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'hidden',
    transition: 'all 0.3s ease-out',
    '& > div': {
      background: theme.palette.common.surface['surface 5'],
      pb: '20px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      maxHeight: 'calc(100vh - 80px)',
      '& > div': {
        padding: '0 20px',
        flex: '1 1 auto',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: theme.palette.action.disabled,
          borderRadius: '10px',
        },
      },
    },
  }),
  open: {
    opacity: 1,
    visibility: 'visible',
    transform: 'translateY(0)',
  },
  margin: (theme: Theme) => ({
    mt: '20px',
    [theme.breakpoints.down('xl')]: {
      mt: '10px',
    },
  }),
  leftSide: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  }),
  historyButton: (theme: Theme, withSecondButton: boolean) => ({
    ml: '24px',
    borderRadius: withSecondButton ? '16px 0 0 16px' : '16px',
    [theme.breakpoints.down('lg')]: {
      p: '14px 9px',
      minWidth: '38px',
      borderRadius: '16px 0 0 16px',
      ml: '8px',
      '& .MuiTypography-root': {
        display: 'none',
      },
      '& .MuiButton-startIcon': {
        m: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      ml: '12px',
    },
  }),
  secondLeftButton: (theme: Theme) => ({
    ml: '4px',
    borderRadius: '0 16px 16px 0',
    [theme.breakpoints.down('lg')]: {
      p: '14px 9px',
      minWidth: '38px',
      borderRadius: 0,
      '& .MuiTypography-root': {
        display: 'none',
      },
      '& .MuiButton-startIcon': {
        m: 0,
      },
    },
  }),
  appAction: (theme: Theme) => ({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '345px',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '400px',
      position: 'relative',
      left: 'auto',
      transform: 'none',
      ml: '4px',
    },
  }),
};
